import { render, staticRenderFns } from "./preference-pages-tab.vue?vue&type=template&id=1369c81b"
import script from "./preference-pages-tab.vue?vue&type=script&lang=js"
export * from "./preference-pages-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports